export default "__VITE_ASSET__DTSn4PdR__"